export default (urlParameters) => {
  return {
    allow_forecast_map_obs_markers: false,
    customize_map_button_default: false,
    customize_map_button: false,
    detail_panel: false,
    favorites_button: false,
    forcast_model_run_selector: false,
    regional_navigation: false,
    map_auto_refresh: false,
    map_favoriting: false,
    map_name_block: false,
    map_selector_button: false,
    mesonet_filter: false,
    mesonet_filter_button: false,
    pinned_map_bar: false,
    points_of_interest: false,
    spot_obs_parameters: false,
    storm_map_selector_button: false,
    storm_header_block: false,
    wind_lease_blocks: false,
    ui_storage_name: 'mapUIStore'
  }
}